module.exports = __webpack_public_path__ + "static/img/icon-eps.e852b29a.svg";